<template>
  <div class="akey-refuel">
        <!-- 搜索框 -->
        <van-search
        v-model="searchForm.name"
        show-action
        clearable
        maxlength="30"
        placeholder="输入店铺/地址名称筛选"
        @clear="clear"
        >
            <template #action>
                <div @click="getList('search')" style="color:#3399FF;">搜索</div>
            </template>
        </van-search>
        <van-divider :style="{ borderColor: '#E6E6E6', margin:'0 0' }" />
        <!-- 筛选项 -->
        <div class="filter">
          <van-dropdown-menu active-color="#3399FF">
            <van-dropdown-item ref="oilItem" :title="searchForm.oil">
                <div class="type-container">
                    <div class="type-item" :class="{ active: activeId === item.key}" v-for="item in oilType" :key="item.value"
                        @click="oilSelect(item)"
                    >
                        {{item.value}}
                    </div>
               </div>
            </van-dropdown-item>
            <van-dropdown-item ref="areaItem" :title="area">
                <!-- @change="changeArea" -->
                <van-area :value="searchForm.areaCode" title=""   :area-list="areaList" confirm-button-text=" " cancel-button-text=" "  @change="changeArea">
                    <div class="columns-bottom" slot="columns-bottom">
                        <div class="cancel" @click="cancelArea">取消</div>
                        <div class="confim" @click="confimArea">确定</div>
                    </div>
                </van-area>
            </van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <!-- 列表 -->
      <div class="content" v-if="data.length > 0">
          <van-list 
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            @load="onLoad"
          >
            <div class="item" v-for="(item,index) in data" :key="index" @click="goDetail(item)">
                <div style="display: flex">
                    <img :src="item.storeImage"/>
                    <div class="center">
                        <div class="name">{{item.storeName}}</div>
                        <div class="price">
                            <div class="red" style="font-size:0.3rem;margin-right: 8px;">
                                <span class="red" style="font-size:0.2rem">￥</span>
                                {{item.partnerPrice}}/L
                            </div>
                            <div class="countryPrice gray">国标价：￥{{item.officialPrice}}/L</div>
                        </div>    
                        <div class="adress">{{item.address}}</div>
                    </div>
                </div>
                <div class="right">
                    <div class="refuel-button" @click.stop="goDetail(item)">一键加油</div>
                    <div class="gray distance">{{item.distance | distanceFilter}}</div>
                </div>
            </div>
          </van-list>

      </div>
       <van-empty
        v-else
        class="custom-image"
        :image="emptyImgUrl"
        description="暂无数据"
        />
      <!-- 付款记录悬浮标 -->
      <div class="pay-record" @click="goPayRecord">
          <img src="@/assets/img/car-life/record.png"/>
      </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import { throttle } from "lodash";

import {
  queryDict,
  getAreaTree,
  getStoreList,
  getStoreDetailUrl,
  findProductList,
  loginNoToken
} from "@/common/api.js";
import pic_default from "@/assets/img/car-life/pic_default.png";
import { cookieSet } from "@/common/cookie";

let pageSize = 10;

export default {
    data(){
        return{
            area: '北京市',
            searchForm:{
                name: '',
                oil: '92#', // activeId: 92,传参用activeId
                areaCode: '110100',// 定位失败则默认北京市
            },
            oilType:[],
            activeId: '92', // 油号默认选中92
            data:[],
            originalDataList: [],
            emptyImgUrl: pic_default,
            areaList: areaList,
            checkedArea: [],
            loading: false,
            finished: false,
            pagination: {
                pageNum: 1,
                pageSize: 100,
                total: 0
            },
            userLat: '39.915119',
            userLng: '116.403963',
            productCode: '',
        }
    },
    computed:{
        params(){
            return{
                phone: this.$route.query.phone,
                productCode: this.productCode,
                storeName: this.searchForm.name,
                storeTypes: [this.activeId],// 油号类型
                areaCode: this.searchForm.areaCode,
                userLat: this.userLat,
                userLng: this.userLng,
                pageNum: this.pagination.pageNum,
                pageSize: this.pagination.pageSize
            }
        }
    },
    filters: {
        distanceFilter(val) {
          const num = Number(val)
          if (!num) {
            return '0m'
          }
          if (num > 1000) {
            return `${(val / 1000).toFixed(2)}km`
          } else {
            return `${num}m`
          }
        }
    },
    async mounted(){
      let token
      if (this.$route.query.authorizeToken) {
        const res = await loginNoToken({
          channelToken: this.$route.query.authorizeToken,
          companyNo: this.$route.query.companyNo,
        })

        token = res.token
        localStorage.setItem("_phone", this.contactPhone);
      }

      if (token &&
        (document.domain.indexOf("vas") > -1 ||
          document.domain.indexOf("zengzhi") > -1)
      ) {
        cookieSet("token", token);
      }

        this.findProductList()
        this.getOilType()
        this.getLocation() // 获取定位

        let province_list = this.areaList.province_list;
        let city_list = this.areaList.city_list;
        Object.keys(province_list).forEach((key, idx) => {
            let city = key.substring(0,2)
            let value = province_list[key]
            this.areaList.city_list[`${city}0000`] = '全' + value.substr(value.length - 1, 1); 
        })
        Object.keys(city_list).forEach((key, idx) => {
            let item = key.substring(0,4)
            if(item != '0000'){
                this.areaList.county_list[`${item}00`] = '全市'
            }  
        })
    },
    methods:{
        async findProductList() {
            const data = {
                categoryCodeList: [this.$route.query.categoryCode],
                pageNum: 1,
                pageSize: 10,
            }
            const res = await findProductList(data)
            if(res.list && res.list.length >0){
                let item = res.list[0]
                this.productCode = item.productCode
                this.getList()
            }
        },

        async getOilType(){
            const res =  await queryDict({code: 'OIL_TYPE',key: ''})
            if (!res) {
                this.$router.push({ path: "/" });
                return;
            }
            this.oilType = res.kvs
        },
        getLocation(){
            AMap.plugin('AMap.Geolocation', () => {
                const geolocation = new AMap.Geolocation({ enableHighAccuracy: true, })
                // 精确定位
                geolocation.getCurrentPosition((locatePositionStatus, positionRes) => {
                    console.log('精确定位',locatePositionStatus, positionRes)
                    if (locatePositionStatus === 'complete') {
                        this.area = positionRes.addressComponent.city || positionRes.addressComponent.province;
                        this.searchForm.areaCode = positionRes.addressComponent.adcode;
                        this.userLat = positionRes.position.lat;
                        this.userLng = positionRes.position.lng;
                        if(this.productCode){
                            this.getList()
                        }
                        
                    }else{
                        // 则定位当前城市
                        geolocation.getCityInfo((locateCityStatus, cityRes) => {
                        console.log('定位城市', locateCityStatus,cityRes)
                        if (locateCityStatus === 'complete') {
                            this.area = cityRes.city;
                            this.searchForm.areaCode = cityRes.adcode;
                            this.userLat = cityRes.center[1];
                            this.userLng = cityRes.center[0];
                            if(this.productCode){
                                this.getList()
                            }
                        } else {
                            console.log('定位失败')
                        }
                        })          
                    }
                })
                
            });
        },
        onLoad(){ 
            this.loading = false;                  
            var arr = [];
            let storeListLength = this.data ? this.data.length : -1;
            let count = storeListLength + pageSize;
            console.log(this.originalDataList.length,count,'count')
            if(this.originalDataList.length > count){
                let originalList = this.originalDataList.concat();
                arr = originalList.splice(0, count);
            }else{
                arr = this.originalDataList
            }
            this.data = arr;
            // 显示数据==总数，隐藏上拉加载
            if (this.data.length >= this.originalDataList.length) {
                this.finished = true;
            }
            
        },
        async getList(value){
            if(value === 'search'){
                // 搜索
                this.resetData()
            }
            const res = await getStoreList(this.params)
            if(res && res.list){
                this.originalDataList = res.list;
                var arr = this.originalDataList.concat()
                if(arr.length > pageSize ){
                    arr = arr.splice(0, pageSize)
                    this.finished = false;
                }
                this.data = arr;
            }else{
                this.data = []
            }          
        },

        clear(){
            this.resetData()
            this.getList()
        },
        
        goDetail:throttle(
            async function(item){
                if(!item.enable){
                    this.$toast('该门店不可用');
                    return
                }
                const params = {
                    storeId: item.storeId,
                    phone: this.$route.query.phone,
                    productCode: this.productCode,
                }
                const res = await getStoreDetailUrl(params)
                if(res){
                    window.location.href = res
                }
            },
            1000,
            { leading: true, trailing: false }
        ),
        goPayRecord(){
            this.$router.push({
                path: '/payRecord',
                query: {
                    phone: this.$route.query.phone,
                    productCode: this.productCode
                },
            });
        },
        oilSelect(item){
            this.activeId = item.key;
            this.searchForm.oil = item.value;
            this.$refs.oilItem.toggle();
            this.resetData();
            this.getList()
        },
        changeArea(data,value){
            console.log(data,value,'area change ')
            this.checkedArea = value;
        },
        confimArea(){
            if(this.checkedArea.length > 0){
                if( ['全省', '全市', '全区'].includes(this.checkedArea[1].name) ) {
                    this.area = this.checkedArea[0].name + '/' + this.checkedArea[1].name;
                } else {
                    this.area = this.checkedArea[1].name + '/' + this.checkedArea[2].name;
                }
                this.searchForm.areaCode = this.checkedArea[2].code;
            }          
            this.$refs.areaItem.toggle();
            this.resetData()
            this.getList()
        },
        cancelArea(){
            this.$refs.areaItem.toggle()
        },
        resetData(){
            this.data = [];
        }
    }
}
</script>
<style>
.van-empty {
  padding: 0;
  margin-top: 1.83rem;
}

.custom-image .van-empty__image {
  width: 3.88rem;
  height: 2.44rem;
}
</style>

<style lang="scss" scoped>
.akey-refuel{
    ::v-deep .van-icon-search:before {
        content: '';
    }
    ::v-deep .van-dropdown-menu__bar{
        box-shadow: none !important;
    }
    ::v-deep .van-picker__toolbar{
        height: 20px;
    }
    .type-container {
        display: flex;
        margin: 20px 25px;
        .type-item{
           width: 75px;
           height: 36px;
           line-height: 36px;
           border: 1px solid #E6E6E6;
           border-radius: 8px;
           text-align: center;
           margin-right: 10px;
           font-size:0.30em;
        }
        .active {
            color: #3399FF;
            background: #CCE6FF;
            border: 1px solid #3399FF;
        }
    }
    .columns-bottom{
        display: flex;
        font-size: .24rem;
        width: 100%;
        height: 40px;
        line-height: 40px;
        .cancel{
            width: 50%;
            text-align: center;
        }
        .confim{
            width: 50%;
            text-align: center;
            color: #fff;
            background: #3399FF;
        }
    }
    .content{
        width: calc(100% - 24px);
        min-height: calc(100vh - 128px);
        padding: 12px;
        background: #F4F6F7;
        .item{
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            padding: 16px;
           
            background: #FFFFFF;
            border-radius: 16px;
            img{
                width: 36px;
                height: 36px;
                margin-right: 12px;
            }
            .center{               
                .name{
                    font-size: 0.3rem;
                    color: #383838;
                    letter-spacing: 0.45px;
                    font-weight: 500;
                }
                .price{
                    display: flex;
                    text-align: center;
                    margin: 10px 0;
                }
                .countryPrice{
                    line-height: 15px;
                    font-size: 0.2rem;
                    letter-spacing: 0.3px;
                    text-decoration: line-through;
                }
                .adress{
                    width:200px;
                    font-size: .24rem;
                    color: #787878;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .right{
                position: relative;
                .refuel-button{
                    width: 69px;
                    height: 24px;
                    font-size: .24rem;
                    color: #fff;
                    background: #3399FF;
                    border-radius: 24px;
                    text-align: center;
                    line-height: 24px;
                }
                .distance{
                    position: absolute;
                    bottom: 0;
                    right: 12px;
                    font-size: .24rem
                }
            }
           
        }
        .red{
            color: #EA3F26;
        }
        .gray{
            color: #C8C8C8;
        }
    }
    .pay-record{
        position: fixed;
        right: 12px;
        bottom: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 42px;
        height: 42px;
        background: rgba(255,255,255,0.84);
        border-radius: 50%;
        box-shadow: 0px 0px 16px 0px rgba(51,153,255,0.3);
        img{
            width: 24px;
            height: 24px;
        }
    }
}

</style>